module.exports = __webpack_public_path__ + "4cb659a70c4b0bd8a521303e06f0a28e.svg";